const capitalizeFirstLetter = (string) => {
  return string[0].toUpperCase() + string.slice(1);
};
const objectRoute = {
  install: (Vue) => {
    Vue.prototype.$objectViewRoute = (object) => {
      if (object) {
        if (object.type) {
          if (object.type === "purchases-deliveries") {
            return {
              name: `View PurchasesDelivery`,
              params: { id: object.id },
            };
          }
          if (object.type === "sales-deliveries") {
            return {
              name: `View SalesDelivery`,
              params: { id: object.id },
            };
          }
          if (object.type === "unit-of-measure-units") {
            if (!object.unitOfMeasure) {
              return "/";
            }
            return {
              name: `View UnitOfMeasure`,
              params: { id: object.unitOfMeasure.id },
            };
          }
          if (object.type === "cash-register-reading-items") {
            return {
              name: `View Product`,
              params: { id: object.product.id },
            };
          }
          if (object.type === "category-equipments") {
            return {
              name: `View CategoryEquipment`,
              params: { id: object.id },
            };
          }
          if (object.type === "supply-rules") {
            return {
              name: `View Supply Rule`,
              params: { id: object.id },
            };
          }
          if (object.type === "files") {
            return {
              name: "Files Explorer",
              query: { file_id: object.id },
            };
          }
          if (object.type === "folders") {
            return {
              name: "Files Explorer",
              query: { folder_id: object.id },
            };
          }
          // Training reminder notification (App\Notifications\TrainingReminder).
          if (object.type === "trainings") {
            return {
              name: "Trainings",
              query: { tab: "path" },
            };
          }
          if (object.type === "options") {
            return {
              name: "List Options",
            };
          }
          if (
            [
              "cash-register-reading-expense-items",
              "cash-register-reading-payment-items",
              "cash-register-reading-invoice-items",
            ].includes(object.type)
          ) {
            return "/";
          }
          if (object.type.split("-").length > 1) {
            const objectRouteName = object.type
              .split("-")
              .map((item) => capitalizeFirstLetter(item))
              .join("")
              .slice(0, -1);
            return {
              name: `View ${objectRouteName}`,
              params: { id: object.id },
            };
          }
          return {
            name: `View ${capitalizeFirstLetter(object.type).slice(0, -1)}`,
            params: { id: object.id },
          };
        }
      }
      return "/";
    };
  },
};

export default objectRoute;
